import styled from 'styled-components'
import theme from '../../common/theme'

export const Button = styled.a`
  background-color: ${theme.color.yellow};
  color: ${theme.color.blue};
  padding: 15px 43px;
  border-radius: 11px;
  cursor: pointer;
  font-weight: 600;
`
